export interface Document {
  id: string;
  org_id: string;
  employee_id: string;
  name: string;
  type: string;
  file_url: string;
  file_size: number | null;
  mime_type: string | null;
  requires_signature: boolean;
  signed_at: string | null;
  expires_at: string | null;
  notes: string | null;
  version?: number;
  is_current_version?: boolean;
  parent_document_id?: string | null;
  template_id?: string | null;
  created_at: string;
  employee_name?: string | null;
  uploaded_by_name?: string | null;
}

export interface DocumentTemplate {
  id: string;
  org_id: string;
  name: string;
  type: string;
  description: string | null;
  content_template: string | null;
  default_requires_signature: boolean;
  default_expires_days: number | null;
  is_active: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  /** Uploaded PDF / DOCX path. Present on rows that have a file
   *  attached; null for legacy markdown-only templates and for
   *  Lenavio default placeholders. */
  file_url?: string | null;
  file_name?: string | null;
  file_size?: number | null;
  /** ``file`` (default — PDF upload) or ``form`` (digital form). */
  template_type?: "file" | "form";
  /** JSON array of FormField definitions when ``template_type === 'form'``. */
  form_schema?: Array<Record<string, unknown>> | null;
}

export type SignatureStatus =
  | "PENDING"
  | "VIEWED"
  | "SIGNED"
  | "DECLINED"
  | "EXPIRED";

export interface SignatureRequest {
  id: string;
  org_id: string;
  document_id: string;
  document_name?: string;
  signer_user_id: string;
  signer_email?: string;
  requested_by: string;
  requested_by_email?: string;
  status: SignatureStatus;
  viewed_at: string | null;
  signed_at: string | null;
  declined_at: string | null;
  decline_reason: string | null;
  reminder_sent_at: string | null;
  expires_at: string | null;
  created_at: string;
}

export interface DocumentVersion {
  id: string;
  name: string;
  version: number;
  is_current_version: boolean;
  parent_document_id: string | null;
  file_url: string;
  file_size: number | null;
  mime_type: string | null;
  uploaded_by: string;
  created_at: string;
}

export interface DocumentAccessLog {
  id: string;
  document_id: string;
  user_id: string;
  user_email?: string;
  action: "VIEW" | "DOWNLOAD";
  ip_address: string | null;
  created_at: string;
}

export const DOC_TYPE_LABELS: Record<string, string> = {
  offer_letter: "Offer Letter",
  nda: "NDA",
  w4: "W-4",
  i9: "I-9",
  policy: "Policy",
  certification: "Certification",
  other: "Other",
};
